import React, { useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { UserContext } from 'src/contexts/userContext';
import { UserType } from 'src/interfaces/UserTypes';
import TicketList from './TicketList';
import TicketDetailPage from './TicketDetail';
import PartnerTicketDetail from './PartnerTicketDetail';

function Tickets() {
  const userCtx = useContext(UserContext);
  // Clients and partners both get the scoped detail page; only admins get the
  // full detail view with priority, assignee and AI diagnosis.
  const isNonAdmin = userCtx?.currentUser?.userType !== UserType.admin;

  // The global ticket dashboard (list) is admin-only. Clients and partners have
  // no list route here — they reach ticket detail from the per-installation
  // Tickets tab; a direct hit on /tickets bounces them home.
  return (
    <Routes>
      <Route
        index
        element={isNonAdmin ? <Navigate to="/" replace /> : <TicketList />}
      />
      <Route
        path=":id"
        element={isNonAdmin ? <PartnerTicketDetail /> : <TicketDetailPage />}
      />
    </Routes>
  );
}

export default Tickets;
